/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { TaskAssignmentType } from '../enums/task-assignment-type.enum';
import {
  ExecutionDto,
  FrequencyEnum,
  RecurringDto,
  ScheduledTaskDto
} from './dtos/scheduled-task.dto';
import { TaskMetaData } from './task.model';
export class ExecutionModel {
  constructor(public taskId: string, public scheduledAt: string) {}
  fromDto(executionModel: ExecutionDto): ExecutionModel {
    return new ExecutionModel(executionModel.task_id, executionModel.scheduled_at);
  }
}

export class RecurringModel {
  constructor(
    public frequency?: FrequencyEnum,
    public options?: {
      every?: number;
      execution_days?: string[];
      execution_day_position?: string;
    },
    public timezone?: string
  ) {}
  fromDto(recurring: RecurringDto): RecurringModel {
    return new RecurringModel(
      recurring.frequency,

      recurring.options ? recurring.options : { execution_days: recurring.execution_days },
      recurring.timezone
    );
  }
}

export class ScheduledTaskModel {
  constructor(
    public taskId: string,
    public taskName: string,
    public workflowName: string,
    public scheduledAt: string,
    public assignedTo: string[] = [],
    public assignedToEmployeeOrEmployeegroup: TaskAssignmentType = TaskAssignmentType.EMPLOYEE,
    public executions: ExecutionModel[] = [],
    public createdAt?: string,
    public updatedAt?: string,
    public recurring?: RecurringModel,
    public meta_data?: TaskMetaData
  ) {}
  fromDto(scheduledTaskDto: ScheduledTaskDto): ScheduledTaskModel {
    let scheduledTaskModel = new ScheduledTaskModel(
      scheduledTaskDto._id,
      scheduledTaskDto.task_name ?? scheduledTaskDto.workflow_name,
      scheduledTaskDto.workflow_name,
      scheduledTaskDto.scheduled_at
    );
    scheduledTaskModel.assignedTo = scheduledTaskDto.assigned_to;
    switch (scheduledTaskDto.assigned_to_employee_or_employeegroup?.toString()) {
      case 'EMPLOYEE':
        scheduledTaskModel.assignedToEmployeeOrEmployeegroup = TaskAssignmentType.EMPLOYEE;
        break;
      case 'EMPLOYEEGROUP':
        scheduledTaskModel.assignedToEmployeeOrEmployeegroup = TaskAssignmentType.EMPLOYEEGROUP;
        break;
    }
    scheduledTaskModel.scheduledAt = scheduledTaskDto.scheduled_at;

    let executionModel = Object.create(ExecutionModel.prototype);
    let executions: ExecutionModel[] = [];
    for (const exectionDto of scheduledTaskDto.executions ?? []) {
      executions.push(executionModel.fromDto(exectionDto));
    }
    if (scheduledTaskDto.recurring) {
      let recurringModel: RecurringModel = Object.create(RecurringModel.prototype).fromDto(
        scheduledTaskDto.recurring
      );
      scheduledTaskModel.recurring = recurringModel;
    }

    scheduledTaskModel.executions = executions;
    scheduledTaskModel.createdAt = scheduledTaskDto.createdAt;
    scheduledTaskModel.updatedAt = scheduledTaskDto.updatedAt;
    scheduledTaskModel.meta_data = scheduledTaskDto.meta_data;

    return scheduledTaskModel;
  }
}
